var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.whichComponent,_vm._g(_vm._b({tag:"component"},'component',_vm.$$attrs(),false),_vm.$listeners),[(_vm.canShowDefaultSlot)?_vm._t("default"):_vm._e(),(_vm.isTruthy)?_vm._t("truthy"):_vm._e(),(!_vm.isTruthy)?_vm._t("falsy"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }